<!--
 * @Date: 2024-02-21 10:17:17
 * @LastEditors: jacky
 * @LastEditTime: 2024-11-15 20:53:37
 * @FilePath: /zl_api_private_web/src/views/webGraspManage/HistoryReriodMonth.vue
 * @Description: 我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我我是描述记得改我
-->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>历史月数据采集</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      历史月数据采集
      <div class="title-btn">
        <el-button
          type="warning"
          plain
          @click="openInitData"
          v-if="$store.state.funcModuleArray.includes(1901020701)"
          >添加采集任务</el-button
        >
        <el-button
          type="warning"
          plain
          @click="exportFile"
          v-if="$store.state.funcModuleArray.includes(1901020702)"
          >导出</el-button
        >
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" :model="filterForm">
            <el-form-item label="采集类型" prop="">
              <el-select size="small" v-model="filterForm.collect_type">
                <el-option label="全部" value=""></el-option>
                <el-option label="网抓历史月采集" value="1"></el-option>
                <el-option label="FTP历史月采集" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select size="small" v-model="filterForm.status">
                <el-option label="全部" value=""></el-option>
                <el-option
                  :label="item.value"
                  :value="item.key"
                  v-for="item in StatusList"
                  :key="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作时间 ">
              <el-date-picker
                value-format="yyyy-MM-dd"
                size="small"
                v-model="filterForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期 "
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              v-if="showFileDiff"
              label="是否对比差异"
            >
              <el-select size="small" v-model="filterForm.is_diff">
                <el-option label="全部" value=""></el-option>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务类型">
              <el-select size="small" v-model="filterForm.scrap_time_type">
                <el-option label="全部" value=""></el-option>
                <el-option label="实时" value="1"></el-option>
                <el-option label="定时" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="filterForm.search_text"
                class="search-text"
                size="small"
                style="width: 300px;margin-bottom: 3px;"
                placeholder="采集对象/操作人/子公司/备注"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条结果</div>
          <el-table
            v-loading="tableDataLoading"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              width="150"
              prop="collect_type_text"
              label="采集类型"
            >
            </el-table-column>
            <el-table-column prop="client_name" label="采集对象" width="200">
              <template slot-scope="scope">
                <div style="display: flex; align-items: flex-start;">
                  <span style="word-break: break-all; word-wrap: break-word;">
                    {{ scope.row.client_name }}
                  </span>
                  <el-tooltip 
                    v-if="scope.row.scrap_time && scope.row.status == 6"
                    :content="`定时采集时间：${scope.row.scrap_time}`" 
                    placement="top"
                  >
                    <img 
                      src="@/assets/img/timed_collection_time.png"
                      style="width: 16px; height: 16px; margin-left: 4px; flex-shrink: 0;"
                    />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="subsidiarynames" label="子公司" width="160">
              <template slot-scope="scope">
                <div
                  class="clamp-2"
                  :title="titleMultiLine(scope.row.subsidiarynames)"
                >
                  {{ scope.row.subsidiarynames }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="collect_month" label="采集月份">
            </el-table-column>
            <el-table-column prop="data_type_text" label="数据类型">
            </el-table-column>
            <el-table-column prop="value_desc" label="取值范围">
            </el-table-column>
            <el-table-column prop="status_desc" label="状态"> </el-table-column>
            <el-table-column
              v-if="showFileDiff"
              prop="is_diff"
              label="是否对比差异"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.is_diff == 1 ? "是" : "否" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="opreate_name" label="操作人">
            </el-table-column>
            <el-table-column prop="update_time" label="操作时间">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <div class="clamp-3" :title="titleMultiLine(scope.row.remark)">
                  {{ scope.row.remark }}
                </div>
              </template>

              <!--              <template slot-scope="scope">-->
              <!--                <span-->
              <!--                  style="-->
              <!--                  overflow: hidden;-->
              <!--                  text-overflow: ellipsis;-->
              <!--                  display: -webkit-box;-->
              <!--                  -webkit-line-clamp: 3;-->
              <!--                  -webkit-box-orient: vertical;-->
              <!--                ">{{scope.row.remark}}</span>-->
              <!--              </template>-->
            </el-table-column>
            <el-table-column prop="remark" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="cencelMonth(scope.row)"
                  v-if="scope.row.status_desc == '进行中' || scope.row.status_desc == '计划中'"
                  type="text"
                  >取消任务</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="历史月采集任务"
      :visible.sync="dialogVisible"
      width="70%"
      @close="cancel"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="rules"
        label-width="120px"
      >
        <div class="card-content">
          <el-form-item label="采集类型" prop="collect_type">
            <div>
              <el-select
                @change="typeChange"
                size="small"
                v-model="addForm.collect_type"
              >
                <el-option label="网抓历史月采集" value="1"></el-option>
                <el-option label="FTP历史月采集" value="3"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="采集对象" prop="client_list">
            <el-tag
              style="
                background-color: #f09601;
                color: #fff;
                padding: 0 15px;
                cursor: pointer;
              "
              type="primary"
              @click="openChooseDealer"
              >选择</el-tag
            >
            <div>
              <template v-if="selectionVal.length > 0">
                <el-tag
                  v-for="(item, index) in selectionVal"
                  :key="`selection-${item.client_id || index}`"
                  style="margin-right: 10px"
                >
                  {{ item.client_name }}
                </el-tag>
              </template>
            </div>
          </el-form-item>

          <el-form-item v-if="subsidiaryList.length > 0" label="子公司">
            <el-tag
              style="
                background-color: #f09601;
                color: #fff;
                padding: 0 15px;
                cursor: pointer;
              "
              type="primary"
              @click="openChooseSubsidiary"
              >选择</el-tag
            >
            <div style="display: flex; flex-wrap: wrap">
              <el-tag
                v-for="(item, index) in selectSubsidiaryList"
                :key="`subsidiary-${item.client_id || index}`"
                style="margin: 0 10px 0 0"
              >
                {{ item.subsidiary_name }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="采集月份" prop="collect_month">
            <el-date-picker
              v-model="addForm.collect_month"
              :picker-options="pickerOptions"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="数据类型" prop="data_type">
            <div v-if="addForm.collect_type == 3">
              <el-checkbox-group v-model="addForm.data_type">
                <el-checkbox label="1" name="type">销售数据</el-checkbox>
                <el-checkbox label="3" name="type">采购数据</el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-if="addForm.collect_type == 1">
              <el-checkbox-group v-model="addForm.task_types">
                <!-- 7-销售月报 1-销售日报 8-采购月报 2-采购日报 3-库存日报 -->
                <el-checkbox label="7" name="type">销售月报</el-checkbox>
                <el-checkbox label="1" name="type">销售日报</el-checkbox>
                <el-checkbox label="8" name="type">采购月报</el-checkbox>
                <el-checkbox label="2" name="type">采购日报</el-checkbox>
                <el-checkbox label="3" name="type">库存日报</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="取值范围" prop="range">
            <div>
              <el-radio-group v-model="addForm.range">
                <el-radio :label="1" :disabled="addForm.range != 1"
                  >自然月</el-radio
                >
                <el-radio :label="2" :disabled="addForm.range != 2"
                  >账期月</el-radio
                >
              </el-radio-group>
            </div>
          </el-form-item>

          <el-form-item
            label="文件拆分"
            prop="is_split_file"
            v-if="showFileSplit"
          >
            <el-radio-group v-model="addForm.is_split_file">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            v-if="
              addForm.data_type.includes('1') &&
              showFileDiff
            "
            label="是否对比差异"
            prop="is_diff"
          >
            <el-radio-group v-model="addForm.is_diff">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="账期时间" v-if="isShowPayment">
            <div v-if="addForm.collect_type == 1">
              <span v-if="companyData.scrap_cycle == 1">/</span>
              <span v-if="companyData.scrap_cycle == 2">
                上月{{ companyData.scrap_start_day }}号至本月{{
                  companyData.scrap_end_day
                }}号
              </span>
            </div>
            <div v-if="addForm.collect_type == 3">
              <span v-if="companyData.ftp_cycle == 1">/</span>
              <span v-if="companyData.ftp_cycle == 2">
                上月{{ companyData.ftp_start_day }}号至本月{{
                  companyData.ftp_end_day
                }}号
              </span>
            </div>
          </el-form-item>
          <el-form-item 
            label="任务类型" 
            prop="scrap_time_type"
            v-if="addForm.collect_type !== '3'"
          >
            <el-radio-group v-model="addForm.scrap_time_type">
              <el-radio label="1">实时</el-radio>
              <el-radio label="2">定时</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item 
            v-if="addForm.scrap_time_type === '2' && addForm.collect_type !== '3'" 
            label="定时采集时间" 
            prop="scrap_time"
          >
            <el-date-picker
              v-model="addForm.scrap_time"
              type="datetime"
              placeholder="选择日期时间"
              :picker-options="scrapTimeOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="defaultTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" class="new-textarea" prop="remark">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="addForm.remark"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- <choose-single-dealer
      ref="chooseSingleDealer"
      @saveChange="dealerSaveChange"
      :is-clear-search-text="true"
      :is-checkbox="true"
      :type="filterForm.status"
    ></choose-single-dealer> -->
    <select-dealer-tran-modal
      ref="selectDealerTranModal"
      @save="dealerSaveChange"
    >
    </select-dealer-tran-modal>
    <SelectSummyModal
      :clientId="clientID"
      ref="SelectSummyModal"
      @save="saveSummy"
    ></SelectSummyModal>
  </div>
</template>

<script>
import {
  enumBusinessList,
  AddwebScrapClientInit,
  SplitgetSplitFileInfo,
  getMonthPage,
  monthPageCancel,
  getCompanyInfo,
  monthAdd
} from "@/api/index";
import ChooseSingleDealer from "@/components/ChooseSingleDealer";
import SelectDealerTranModal from "@/components/SelectDealerTranModal";
import SelectSummyModal from "@/components/SelectSummyModal";
import { titleMultiLine } from "@/util";
import { exportHistoryReriodMonth } from "@/api/export";
import moment from "moment";
export default {
  name: "InitializationData",
  components: {
    ChooseSingleDealer,
    SelectDealerTranModal,
    SelectSummyModal
  },
  data() {
    var datePass = (rule, value, callback) => {
      if (value === "" || !value) {
        callback(new Error("请选择采集月份"));
      } else {
        let diff = this.getDiffMonth(value[0], value[1]);
        if (diff > 6) {
          callback(new Error("最多只能选择6个月"));
        } else {
          callback();
        }
      }
    };
    var clientListPass = (rule, value, callback) => {
      if (!this.selectionVal || this.selectionVal.length == 0) {
        callback(new Error("请选择采集对象"));
      } else {
        callback();
      }
    };
    return {
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      selectionVal: [],
      totalPage: 1,
      reportTypeMap: [],
      filterForm: {
        status: "",
        collect_type: "",
        date: "",
        is_diff: "",
        search_text: "",
        scrap_time_type: ""
      },
      dialogVisible: false,
      loading: false,
      isShowPayment: false,
      rules: {
        collect_type: [
          { required: true, message: "请选择采集类型", trigger: "blur" }
        ],
        collect_month: [
          { validator: datePass, required: true, trigger: "blur" }
        ],
        client_list: [
          { validator: clientListPass, required: true, trigger: "blur" }
        ],
        data_type: [
          { required: true, message: "请选择数据类型", trigger: "blur" }
        ],
        range: [{ required: true, message: "请选择取值范围", trigger: "blur" }],
        is_split_file: [
          { required: true, message: "请选择是否拆分", trigger: "blur" }
        ],
        is_diff: [
          { required: true, message: "请选择是否对比差异", trigger: "blur" }
        ],
        scrap_time_type: [
          { required: true, message: "请选择任务类型", trigger: "change" }
        ],
        scrap_time: [
          { required: true, message: "请选择定时采集时间", trigger: "change" }
        ],
        remark: [{ message: "", trigger: "blur" }]
      },
      form: {
        selectDealer: "",
        clientText: ""
      },
      addForm: {
        collect_type: "",
        collect_month: "",
        data_type: ["1"],
        task_types: ["7"],
        range: "",
        remark: "",
        is_split_file: "1",
        is_diff: "0",
        scrap_time_type: "1",
        scrap_time: ""
      },
      StatusList: [],
      tableDataLoading: false,
      clientID: 0,
      subsidiaryCount: 0,
      page: 1,
      companyData: {},
      pickerOptions: {
        disabledDate(time) {
          let nowDateStr = `${moment(new Date()).format(
            "YYYY-MM-"
          )}01 00:00:00`;
          time = `${moment(new Date(time)).format("YYYY-MM-")}01 00:00:00`;
          let currentDate = new Date(nowDateStr);
          currentDate.setMonth(currentDate.getMonth() - 24);

          return new Date(time) < currentDate || new Date(time) > new Date();
        }
      },
      subsidiaryList: [],
      selectSubsidiaryList: [],
      defaultTime: new Date().toTimeString().slice(0,8),
      scrapTimeOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  watch: {
    "addForm.range": function(val) {
      this.isShowPayment = this.addForm.range == 2;
    },
    "addForm.collect_type": function(val) {
      if (this.addForm.collect_type == 1) {
        this.addForm.range = this.companyData.scrap_cycle;
      } else if (this.addForm.collect_type == 3) {
        this.addForm.range = this.companyData.ftp_cycle;
      }
    },
    'addForm.scrap_time_type'(val) {
      if (val === '2' && !this.addForm.scrap_time) {
        this.addForm.scrap_time = moment().format('YYYY-MM-DD HH:mm:ss');
      }
    }
  },
  mounted() {
    this.getenumBusinessList();
  },
  methods: {
    titleMultiLine,
    getDiffMonth(start, end) {
      let startDate = moment(start).format("YYYY-MM-DD");
      let endDate = moment(end).format("YYYY-MM-DD");

      let start_date_arr = startDate.split("-");
      let start_months =
        parseInt(start_date_arr[0]) * 12 + parseInt(start_date_arr[1]);
      let end_date_arr = endDate.split("-");
      let end_months =
        parseInt(end_date_arr[0]) * 12 + parseInt(end_date_arr[1]);
      return Math.abs(end_months - start_months);
    },
    getenumBusinessList() {
      let par = {
        enum_name_arr: ["HistoryReriodMonthStatusEnum"]
      };
      enumBusinessList(par).then(res => {
        if (res.status == 0) {
          this.StatusList = res.data[0].HistoryReriodMonthStatusEnum;
          this._getList(1);
        }
      });
    },
    _getList(page) {
      this.tableDataLoading = true;
      let filterForm = { ...this.filterForm };
      if (filterForm.date && filterForm.date !== "") {
        filterForm.start_date = filterForm.date[0];
        filterForm.end_date = filterForm.date[1];
      } else {
        filterForm.start_date = "";
        filterForm.end_date = "";
      }
      delete filterForm.date;
      filterForm.page = page;
      // filterForm.status = !filterForm.status ? "0" : filterForm.status;
      console.log(filterForm);
      getMonthPage(filterForm).then(res => {
        this.tableDataLoading = false;
        if (0 === res.status) {
          let list = res.data.list;

          for (const item of list) {
            let subsidiaryNameArr = [];
            if (item.subsidiary && item.subsidiary.length) {
              for (const item1 of item.subsidiary) {
                subsidiaryNameArr.push(item1.subsidiary_name);
              }
              item.subsidiarynames = subsidiaryNameArr.join(",");
            } else {
              item.subsidiarynames = "";
            }
          }

          console.log(list, "listlistlist");
          this.tableData = list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    onSearch() {
      this._getList(1);
    },
    handleCurrentChange(val) {
      this.page = val;
      this._getList(val);
    },
    cancel() {
      this.dialogVisible = false;
      this.loading = false;
      this.addForm = {
        data_type: ["1"],
        task_types: ["7"],
        scrap_time_type: "1",
        scrap_time: "",
        is_split_file: "1",
        // ... 其他重置字段
      };
      this.selectionVal = [];
      this.selectSubsidiaryList = [];
      this.subsidiaryList = [];
    },
    confirm() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let values = { ...this.addForm };
          
          if (values.scrap_time_type === '2') {
            const now = moment();
            const selectedTime = moment(values.scrap_time);
            if (selectedTime.isBefore(now)) {
              this.$message.error('采集开始时间不能早于当前时间');
              this.loading = false;
              return;
            }
          }

          if (values.range == 2) {
            let diff = this.getDiffMonth(
              values.collect_month[0],
              values.collect_month[1]
            );

            if (diff < 1) {
              this.$message.warning(
                "按账期月取值，采集月份至少需要两个月的数据"
              );
              this.loading = false;
              return;
            }
          }
          for (let i = 0; i < values.collect_month.length; i++) {
            values.collect_month[i] = moment(values.collect_month[i]).format(
              "YYYY-MM"
            );
          }
          let type;
          if (values.collect_type == 1) {
            type = this.isNewSystem == 1 ? 1 : 2;
          } else if (values.collect_type == 3) {
            type = 3;
          }
          if (values.collect_month[0] == values.collect_month[1]) {
            values.collect_month.splice(1, 1);
          }

          console.log(this.selectionVal, "this.selectionValthis.selectionVal");
          let clientList = [];
          if (
            this.selectionVal.length == 1 &&
            this.selectionVal[0].client_array
          ) {
            this.selectionVal[0].client_array.forEach(item => {
              let obj = {
                client_code: item.client_code,
                client_id: item.client_id,
                client_name: item.client_name,
                remark: values.remark,
                data_type: values.data_type.length
                  ? values.data_type.join(",")
                  : values.data_type,
                task_types: values.task_types.length
                  ? values.task_types.join(",")
                  : values.task_types,
                collect_month: values.collect_month,
                is_split_file: values.is_split_file,
                scrap_time_type: values.scrap_time_type,
                scrap_time: values.scrap_time_type === '2' ? values.scrap_time : ''
              };
              if (this.isNewSystem == 0) {
                obj.broker_code = item.broker_code;
                obj.broker_name = item.broker_name;
              }
              if (values.data_type.includes("1")) {
                obj.is_diff = values.is_diff;
              }
              if (this.selectSubsidiaryList.length) {
                if (
                  this.selectSubsidiaryList.length == 1 &&
                  this.selectSubsidiaryList[0].subsidiary_name == "全部"
                ) {
                  obj.sub_client_id_list = this.selectSubsidiaryList[0].client_id;
                } else {
                  obj.sub_client_id_list = this.selectSubsidiaryList.map(
                    item => item.client_id
                  );
                }
              }
              clientList.push(obj);
            });
          } else {
            this.selectionVal.forEach(item => {
              let obj = {
                client_code: item.client_code,
                client_id: item.client_id,
                client_name: item.client_name,
                remark: values.remark,
                data_type: values.data_type.length
                  ? values.data_type.join(",")
                  : values.data_type,
                task_types: values.task_types.length
                  ? values.task_types.join(",")
                  : values.task_types,
                collect_month: values.collect_month,
                is_split_file: values.is_split_file,
                scrap_time_type: values.scrap_time_type,
                scrap_time: values.scrap_time_type === '2' ? values.scrap_time : ''
              };
              if (this.isNewSystem == 0) {
                obj.broker_code = item.broker_code;
                obj.broker_name = item.broker_name;
              }
              if (values.data_type.includes("1")) {
                obj.is_diff = values.is_diff;
              }
              if (this.selectionVal.length && this.selectionVal.length == 1) {
                if (this.selectSubsidiaryList.length) {
                  if (
                    this.selectSubsidiaryList.length == 1 &&
                    this.selectSubsidiaryList[0].subsidiary_name == "全部"
                  ) {
                    obj.sub_client_id_list = this.selectSubsidiaryList[0].client_id;
                  } else {
                    obj.sub_client_id_list = this.selectSubsidiaryList.map(
                      item => item.client_id
                    );
                  }
                }
              }
              clientList.push(obj);
            });
          }
          let data = JSON.stringify({ clientList: clientList });

          let parameter = {
            type,
            data
          };
          monthAdd(parameter).then(res => {
            this.loading = false;
            this.dialogVisible = false;
            if (0 === res.status) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.addForm = { data_type: ["1"], task_types: ["7"] };
              this.selectionVal = [];
            } else {
              this.$message.error(res.msg);
            }
            this._getList(1);
          });
        }
      });
    },
    openChooseDealer() {
      // this.$refs.chooseSingleDealer.openDialog(this.selectionVal);
      this.$refs.selectDealerTranModal.openModal(
        this.selectionVal,
        this.addForm.collect_type
      );
    },
    dealerSaveChange(selectionVal, isNewSystem) {
      this.isNewSystem = isNewSystem;
      this.selectionVal = selectionVal;
      console.log(selectionVal, "selectionValselectionVal");

      if (this.selectionVal.length && this.selectionVal.length == 1) {
        this.clientID = Number(this.selectionVal[0].client_id);
        let broker_code = this.selectionVal[0].broker_code;

        SplitgetSplitFileInfo("", this.clientID, "1,3", broker_code).then(
          res => {
            if (res.status === 0) {
              if (res.data.client) {
                this.subsidiaryList = res.data.subsidiary;
              } else {
                this.subsidiaryList = [];
              }
            } else {
              this.subsidiaryList = [];
            }
            this.selectSubsidiaryList = [];
          }
        );
      }
    },
    async openInitData() {
      let res = await getCompanyInfo();
      if (res.status == 0) {
        this.companyData = res.data;
      }
      this.dialogVisible = true;
      this.addForm.collect_type = "1";
    },
    cencelMonth(obj) {
      let history_period_month_id = obj.history_period_month_id;
      monthPageCancel({ history_period_month_id }).then(res => {
        if (res.status == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
      setTimeout(() => {
        this._getList();
      }, 2000);
    },
    typeChange(e) {
      this.selectionVal = [];
      if (e == 1) {
        this.addForm.range = this.companyData.scrap_cycle;
      } else if (e == 3) {
        this.addForm.range = this.companyData.ftp_cycle;
      }
    },
    exportFile() {
      let filterForm = { ...this.filterForm };
      if (filterForm.date && filterForm.date !== "") {
        filterForm.start_date = filterForm.date[0];
        filterForm.end_date = filterForm.date[1];
      } else {
        filterForm.start_date = "";
        filterForm.end_date = "";
      }
      delete filterForm.date;
      filterForm.page = this.page;

      exportHistoryReriodMonth(filterForm);
    },

    // 选择子公司
    openChooseSubsidiary() {
      this.$refs.SelectSummyModal.openModal(this.selectSubsidiaryList);
    },
    // 选择子公司回调
    saveSummy(e) {
      this.selectSubsidiaryList = [...e];
      console.log(e, "Eeeeeeee");
    }
  },
  computed: {
    showFileSplit() {
      return this.$store.state.companyInfo 
        && this.$store.state.companyInfo.account_row 
        && this.$store.state.companyInfo.account_row.show_file_split === 1;
    },
    showFileDiff() {
      return this.$store.state.companyInfo 
        && this.$store.state.companyInfo.account_row 
        && this.$store.state.companyInfo.account_row.show_file_diff === 1;
    }
  }
};
</script>

<style scoped>
.clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.clamp-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
